const DEFAULT_LANGUAGE = 'en';

const SCRIPT_URL = 'https://dev.shift4.com/checkout.js';

const SUPPORTED_LANGUAGES = [
  'be',
  'bg',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'hr',
  'hu',
  'it',
  'lt',
  'lv',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
];

export { DEFAULT_LANGUAGE, SCRIPT_URL, SUPPORTED_LANGUAGES };
